import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useQueryJobCount from "../view/useQueryJobCount.js";
import JobStatusEnum from "../../jobs/JobStatusEnum.js";

export default function PublishedJobByEmployerCountItem(props) {
  const { employerId } = props;
  const { data: count, loading, errors } = useQueryJobCount({employerId, status: JobStatusEnum.PUBLISHED});

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <Row>
            <Col>
              <span>{count}</span>
            </Col>
          </Row>
        )}
      />
    </HorizontalLoader>
  );
}
